"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createEllipsis = (string, maxLength) => {
    let count = 0;
    let result = "";
    for (let i = 0; i < string.length; i++) {
        // eslint-disable-next-line security/detect-object-injection
        if (string[i] !== " ") {
            count++;
        }
        if (count > maxLength - 3) {
            return `${result}...`;
        }
        // eslint-disable-next-line security/detect-object-injection
        result += string[i];
    }
    return result;
};
exports.default = createEllipsis;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlRWxsaXBzaXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvY3JlYXRlRWxsaXBzaXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFNLGNBQWMsR0FBRyxDQUFDLE1BQWMsRUFBRSxTQUFpQixFQUFVLEVBQUU7SUFDbkUsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFDO0lBQ2QsSUFBSSxNQUFNLEdBQUcsRUFBRSxDQUFDO0lBRWhCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxNQUFNLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFLENBQUM7UUFDdkMsNERBQTREO1FBQzVELElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxLQUFLLEdBQUcsRUFBRSxDQUFDO1lBQ3RCLEtBQUssRUFBRSxDQUFDO1FBQ1YsQ0FBQztRQUNELElBQUksS0FBSyxHQUFHLFNBQVMsR0FBRyxDQUFDLEVBQUUsQ0FBQztZQUMxQixPQUFPLEdBQUcsTUFBTSxLQUFLLENBQUM7UUFDeEIsQ0FBQztRQUNELDREQUE0RDtRQUM1RCxNQUFNLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ3RCLENBQUM7SUFFRCxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDLENBQUM7QUFFRixrQkFBZSxjQUFjLENBQUMifQ==